var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateView',[_c('div',{staticClass:"container"},[_c('TemplatePageGrid',{attrs:{"items":_vm.workProjectTypeGrid,"page-data":_vm.pageData,"loading":_vm.loadingAnimation},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [(
            _vm.$userCheckAccess({
              abilities: 'edit_project_types',
            })
          )?_c('ProjectTypeModal',{attrs:{"create":true}}):_vm._e()]},proxy:true}])},[_c('ProjectTypeTable',{attrs:{"workProjectTypeGrid":_vm.workProjectTypeGrid}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }